//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LensdescriptionCard from '~/components/linses/main-page/LensDescriptionCard'

export default {
  name: 'LinsesDescriptionBlock',
  components: {LensdescriptionCard},
  props: {
    lens: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    description() {
      return this?.lens?.description || "";
    },
    lenses() {
      return this?.lens?.lenses || [];
    },
  },
}
